import { Chip, Tooltip } from "@mui/material";

const STATUS_CONFIG = {
  PENDING: { label: "Pending Verification", color: "warning" },
  VERIFIED: { label: "Verified", color: "success" },
  REJECTED: { label: "Rejected", color: "error" },
  IMPORTED: { label: "Imported", color: "info" },
};

const AccountVerificationChip = ({ status, rejectionFeedback, size = "small" }) => {
  if (!status || status === "DRAFT") return null;
  const config = STATUS_CONFIG[status];
  if (!config) return null;

  const chip = <Chip label={config.label} color={config.color} size={size} />;

  if (status === "REJECTED" && rejectionFeedback) {
    return (
      <Tooltip title={`Feedback: ${rejectionFeedback}`} arrow>
        <span>{chip}</span>
      </Tooltip>
    );
  }
  return chip;
};

export default AccountVerificationChip;
